import type { ShareAction } from '#src/app/shared/hooks/share';
import { useAvailableShareActions } from '#src/app/shared/hooks/share';

import type { CommentShareChannel, PartialComment, PartialPetition, ShareConfig } from '../types';

import { useCommentShareOptions } from './options';

const CHANNELS: readonly CommentShareChannel[] = ['facebook', 'twitter'];

export function useCommentAvailableShareActions(
	comment: PartialComment,
	petition: PartialPetition,
	config: ShareConfig,
): ReadonlyArray<ShareAction<CommentShareChannel>> {
	const options = useCommentShareOptions(comment, petition, config);
	const shareChannels = useAvailableShareActions(CHANNELS, options);

	return shareChannels;
}
